import { router } from '../_helpers'
export const message = {
  namespaced: true,
  state: {
    type: '',
    message: '',
    enroll: null,
    userEnroll: null

  },
  actions: {
    error ({ commit }, message) {
      commit('error', message)
      router.push('/messaggio')
    },
    success ({ commit }, message) {
      commit('success', message)
      router.push('/messaggio')
    },
    enrollment ({ commit }, { enroll, success, message, userEnroll }) {
      var suffix = 'Error'
      if (success) { suffix = 'Success' }

      commit(`enrollment${suffix}`, { enroll: enroll, message: message, userEnroll: userEnroll })
      router.push('/messaggio')
    },

    enrollmentConfirm ({ commit }, { enroll, success, message }) {
      var suffix = 'Error'
      if (success) { suffix = 'Success' }

      console.log('message.module', suffix)
      commit(`enrollmentConfirm${suffix}`, { enroll: enroll, message: message })
      router.push('/messaggio')
    },

    enrollmentCancellation ({ commit }, { enroll, success, message }) {
      var suffix = 'Error'
      if (success) { suffix = 'Success' }
      commit(`enrollmentCancellation${suffix}`, { enroll: enroll, message: message })
      router.push('/messaggio')
    }

  },
  mutations: {
    error (state, message) {
      state.type = 'genericError'
      state.message = message
    },

    success (state, message) {
      state.type = 'success'
      state.message = message
    },
    enrollmentError (state, value) {
      state.type = 'enrollmentError'
      state.message = value.message
      state.course = value.course
    },

    enrollmentSuccess (state, value) {
      state.type = 'enrollmentSuccess'
      state.message = value.message
      state.enroll = value.enroll
      state.userEnroll = value.userEnroll
    },

    enrollmentConfirmSuccess (state, value) {
      state.type = 'enrollmentConfirmation'
      state.message = value.message
      state.enroll = value.enroll
    },
    enrollmentConfirmError (state, value) {
      state.type = 'enrollmentConfirmationError'
      state.message = value.message
      state.enroll = value.enroll
    },

    enrollmentCancellationSuccess (state, value) {
      state.type = 'enrollmentCancellation'
      state.message = value.message
      state.enroll = value.enroll
    },
    enrollmentCancellationError (state, value) {
      state.type = 'enrollmentCancellationError'
      state.message = value.message
      state.enroll = value.enroll
    }
  }
}
